module.exports = __webpack_public_path__ + "img/arrow-left-black.d620c012.svg";